import PropTypes from "prop-types";
import CalendarIcon from "../../assets/img/icons/calendar.svg";

export default function Date({ children }) {
	return (
		<span>
			<i>
				<img src={CalendarIcon} alt="date" />
			</i>
			{children}
		</span>
	);
}

Date.propTypes = {
	children: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};
